import { get } from 'lodash';
import { GetServerSidePropsContext, InferGetServerSidePropsType } from 'next';
import React, { FC } from 'react';
import SEOTags from '~/components/SEOTags';
import { SectionsKey } from '~/constants/enum';
import { QUERY_GET_ALL_REVIEWS } from '~/data/home';
import Layout from '~/layouts/ThemeLayout';
import { initializeApollo } from '~/utils/apollo-client';
import { getPageStruct, renderSectionNew } from '~/utils/pageTwo';
import { getTheme } from '~/utils/theme';

const pageStruct = getPageStruct(getTheme(), 'reviews');

const sections: any = pageStruct?.children
    ?.sort((a: any, b: any) => a.order - b.order)
    .map((item: any, index: number) => {
        const Section = renderSectionNew(item);
        return {
            id: item.id,
            order: item.order,
            dataKey: item.dataKey,
            component: Section
        };
    });

const ReviewsPage: FC<InferGetServerSidePropsType<typeof getServerSideProps>> = ({ reviews }) => {
    const sectionData = {
        [SectionsKey.Reviews]: {
            data: reviews
        }
    };

    return (
        <Layout>
            <SEOTags title="Reviews" />
            <div className="flex flex-col gap-8">
                {sections?.map((item: any, index: number) => {
                    const Section = item.component;
                    return (
                        <React.Fragment key={`section-${index}`}>
                            {Section ? <Section {...get(sectionData, item.dataKey, {})} /> : null}
                        </React.Fragment>
                    );
                })}
            </div>
        </Layout>
    );
};

export default ReviewsPage;

export async function getServerSideProps({ params, query }: GetServerSidePropsContext) {
    const apolloClient = initializeApollo();
    const sort: string = (query?.sort as string) ?? '';

    try {
        const { data } = await apolloClient.query({
            query: QUERY_GET_ALL_REVIEWS,
            variables: {
                pageSize: query?.pageSize || 12,
                currentPage: query?.currentPage || 1,
                sort:
                    sort.split('-')?.length > 0
                        ? {
                              [sort.split('-')[0]]: sort.split('-')[1]
                          }
                        : undefined
            }
        });

        return {
            props: {
                initialApolloState: apolloClient.cache.extract(),
                meta: {
                    title: 'Reviews',
                    description: 'Reviews'
                },
                reviews: data?.allReview
            }
        };
    } catch (error) {
        console.error('Error fetching reviews:', error);
        return {
            props: {
                initialApolloState: apolloClient.cache.extract(),
                meta: {
                    title: 'Reviews',
                    description: 'Reviews'
                },
                reviews: []
            }
        };
    }
}
